import { render, staticRenderFns } from "./LinkOutdated.vue?vue&type=template&id=2850e6ee&scoped=true&"
import script from "./LinkOutdated.vue?vue&type=script&lang=js&"
export * from "./LinkOutdated.vue?vue&type=script&lang=js&"
import style0 from "./LinkOutdated.vue?vue&type=style&index=0&id=2850e6ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850e6ee",
  null
  
)

export default component.exports